// application パックから読み込まれるため、サインアップモーダルが無いページでも実行される。
// 以前は layouts/_signup_modal からだけ読まれていたので要素の存在を前提に書けていた。
const signupFormModal = document.querySelector('.js-signup-form-modal');
if (signupFormModal) {
  document.querySelectorAll('.js-signup-form-trigger').forEach(trigger => {
    trigger.addEventListener('click', () => {
      signupFormModal.classList.add('is-active');
      document.getElementById('user_organization_attributes_name').focus();
    })
  })

  const closeBtn = document.querySelector('.js-signup-form-modal-close');
  closeBtn.addEventListener('click', () => {
    signupFormModal.classList.remove('is-active');
  })

  window.addEventListener('keydown', (event) => {
    switch (event.key) {
      case  'Escape':
        signupFormModal.classList.remove('is-active');
    }
  })
}
